<mat-progress-bar mode="indeterminate" [ngClass]="requestRunning ? 'show' : 'hide'"></mat-progress-bar>
<div id="ml-prompt-wrapper">
    <div class="section" id="header-section">
        <h2>Header</h2>
        <ml-prompt-field [(prompt)]="headerPrompt" (promptChange)="onHeaderPromptChange($event)"
            placeholder="Enter a prompt to generate headers.">
        </ml-prompt-field>
        <button mat-stroked-button color="primary" class="generate" (click)="generateHeaders()"
            [disabled]="requestRunning">Generate</button>
        <hr>
        <ml-result-field [responses]="data.headerResponses" [requestRunning]="requestRunning"
            (responseAccepted)="acceptHeader($event)" (responseRejected)="rejectHeader($event)">
        </ml-result-field>
    </div>

    <div class="section" id="paragraph-section">
        <h2>Paragraph</h2>
        <ml-prompt-field [(prompt)]="paragraphPrompt" (promptChange)="onParagraphPromptChange($event)"
            placeholder="Enter a prompt to generate a paragraph.">
        </ml-prompt-field>
        <button mat-stroked-button color="primary" class="generate" (click)="generateParagraph()"
            [disabled]="requestRunning">Generate</button>
        <hr>
        <ml-result-field [responses]="data.paragraphResponse" [requestRunning]="requestRunning"
            (responseAccepted)="acceptParagraph($event)" (responseRejected)="rejectParagraph($event)">
        </ml-result-field>
    </div>
</div>